import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const LINKS = [
  ['/explore', 'Explore attractions'],
  ['/events', "What's On"],
  ['/towns', 'Market towns'],
  ['/accommodation', 'Places to stay'],
  ['/plan', 'Plan My Day'],
];

export default function NotFoundPage() {
  return (
    <div className="bg-base min-h-[60vh] flex items-center" data-testid="not-found-page">
      <Helmet>
        <title>Page not found · GoLeicestershire</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="max-w-[800px] mx-auto px-6 py-20 text-center">
        <div className="label text-heritage mb-3">404 — page not found</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-4">That page has wandered off.</h1>
        <p className="text-charcoal/70 leading-relaxed mb-8">
          The page you&apos;re after doesn&apos;t exist — it may have moved when we rebuilt the site.
          Try one of these instead:
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {LINKS.map(([to, label]) => (
            <Link key={to} to={to} data-testid={`nf-link-${to.replace('/', '')}`}
              className="bg-heritage text-cream font-semibold rounded-full px-5 py-2.5 text-sm hover:bg-heritage/90 transition-colors">
              {label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
